import {
  SHOW_DELETE_CONFIRMATION_MODAL,
  HIDE_DELETE_CONFIRMATION_MODAL,
  SET_CONTENT_NAME,
  SET_DELETE_CALLBACK,
  SET_CANCEL_CALLBACK,
  SET_CONTENT_TYPE,
} from '../constants';

export const showDeleteConfirmationModal = dispatch => {
  dispatch({
    type: SHOW_DELETE_CONFIRMATION_MODAL,
    payload: true,
  });
};

export const setContentName = contentName => ({
  type: SET_CONTENT_NAME,
  payload: contentName,
});
export const setContentType = contentType => ({
  type: SET_CONTENT_TYPE,
  payload: contentType,
});

export const setDeleteCallback = callback => ({
  type: SET_DELETE_CALLBACK,
  payload: callback,
});

export const setCancelCallback = callback => ({
  type: SET_CANCEL_CALLBACK,
  payload: callback,
});

export const hideDeleteConfirmationModal = dispatch => {
  dispatch({
    type: HIDE_DELETE_CONFIRMATION_MODAL,
    payload: false,
  });
};
